import { render, staticRenderFns } from "./InventoryOverview.vue?vue&type=template&id=24a1cc00&scoped=true"
import script from "./InventoryOverview.vue?vue&type=script&lang=js"
export * from "./InventoryOverview.vue?vue&type=script&lang=js"
import style0 from "./InventoryOverview.vue?vue&type=style&index=0&id=24a1cc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1cc00",
  null
  
)

export default component.exports